module.exports = __webpack_public_path__ + "static/media/Marker-1.c2204d87.png";